import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../api/axios';

export default function Login() {
  const [tab, setTab] = useState('email'); // 'email' | 'phone'
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [phone, setPhone] = useState('');
  const [otp, setOtp] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { login, loginWithToken } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  const handleSendOtp = async () => {
    if (!phone) return setError('Enter your WhatsApp number');
    setLoading(true); setError('');
    try {
      await api.post('/auth/send-login-otp', { phone });
      setOtpSent(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to send OTP');
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    if (!otp) return setError('Enter the OTP');
    setLoading(true); setError('');
    try {
      const res = await api.post('/auth/verify-login-otp', { phone, otp });
      await loginWithToken(res.data.token, res.data.user);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Verification failed');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = { width: '100%', padding: '12px 14px', border: '1px solid #e5e7eb', borderRadius: 10, fontSize: 14, marginBottom: 12, boxSizing: 'border-box' };
  const tabBtn = (active) => ({
    flex: 1, padding: '10px', border: 'none', background: active ? '#25D366' : '#f3f4f6',
    color: active ? '#fff' : '#374151', fontWeight: 600, fontSize: 13, cursor: 'pointer'
  });

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #0f8f5f, #0c7a50)', fontFamily: 'DM Sans, sans-serif'
    }}>
      <div style={{ background: '#fff', padding: 40, borderRadius: 18, width: 360, boxShadow: '0 20px 50px rgba(0,0,0,.15)', textAlign: 'center' }}>
        <h2 style={{ marginBottom: 8, color: '#111' }}>VFlow Login</h2>
        <p style={{ color: '#6b7280', fontSize: 13, marginBottom: 20 }}>WhatsApp Business Dashboard</p>

        <div style={{ display: 'flex', borderRadius: 10, overflow: 'hidden', marginBottom: 20, border: '1px solid #e5e7eb' }}>
          <button type="button" onClick={() => { setTab('email'); setError(''); }} style={tabBtn(tab === 'email')}>Email</button>
          <button type="button" onClick={() => { setTab('phone'); setError(''); }} style={tabBtn(tab === 'phone')}>Phone OTP</button>
        </div>

        {error && (
          <div style={{ background: '#fee2e2', color: '#991b1b', padding: '10px 14px', borderRadius: 8, marginBottom: 16, fontSize: 13, textAlign: 'left' }}>
            {error}
          </div>
        )}

        {tab === 'email' && (
          <form onSubmit={handleSubmit}>
            <input type="email" placeholder="Email" value={email}
              onChange={e => setEmail(e.target.value)} required style={inputStyle} />
            <div style={{ position: 'relative', marginBottom: 16 }}>
              <input type={showPassword ? 'text' : 'password'} placeholder="Password" value={password}
                onChange={e => setPassword(e.target.value)} required
                style={{ ...inputStyle, marginBottom: 0, paddingRight: 40 }} />
              <span onClick={() => setShowPassword(!showPassword)}
                style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', fontSize: 16, color: '#6b7280', userSelect: 'none' }}>
                {'👁️'}
              </span>
            </div>
            <button type="submit" disabled={loading}
              style={{ width: '100%', padding: '12px', background: '#25D366', color: '#fff', border: 'none', borderRadius: 10, fontSize: 15, fontWeight: 600, cursor: 'pointer' }}>
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>
        )}

        {tab === 'phone' && (
          <div>
            <input type="tel" placeholder="91XXXXXXXXXX" value={phone}
              disabled={otpSent} onChange={e => setPhone(e.target.value)} style={inputStyle} />
            {!otpSent ? (
              <button type="button" onClick={handleSendOtp} disabled={loading}
                style={{ width: '100%', padding: '12px', background: '#25D366', color: '#fff', border: 'none', borderRadius: 10, fontSize: 15, fontWeight: 600, cursor: 'pointer' }}>
                {loading ? 'Sending OTP...' : 'Send OTP'}
              </button>
            ) : (
              <>
                <input type="text" placeholder="Enter 6-digit OTP" value={otp} maxLength={6}
                  onChange={e => setOtp(e.target.value.replace(/\D/g, ''))}
                  style={{ ...inputStyle, textAlign: 'center', letterSpacing: '0.4rem', fontWeight: 700, fontSize: 18 }} />
                <button type="button" onClick={handleVerifyOtp} disabled={loading}
                  style={{ width: '100%', padding: '12px', background: '#25D366', color: '#fff', border: 'none', borderRadius: 10, fontSize: 15, fontWeight: 600, cursor: 'pointer', marginBottom: 8 }}>
                  {loading ? 'Verifying...' : 'Verify & Login'}
                </button>
                <button type="button" onClick={() => { setOtpSent(false); setOtp(''); setError(''); }}
                  style={{ width: '100%', background: 'none', border: 'none', color: '#6b7280', fontSize: 13, cursor: 'pointer', padding: '6px' }}>
                  ← Change number
                </button>
              </>
            )}
          </div>
        )}

        <p style={{ marginTop: 16, fontSize: 13, color: '#6b7280' }}>
          Don't have an account?{' '}
          <a href='/register' style={{ color: '#25D366', fontWeight: 600, textDecoration: 'none' }}>Register</a>
        </p>
      </div>
    </div>
  );
}
